import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SwiperModule } from 'swiper/angular';
import { MaterialModule } from '@/material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { SharedModule } from '../../shared.module';
import { MarketplaceCardComponent } from './marketplace-card.component';
import { QuickViewDialogComponent } from './quick-view-dialog/quick-view-dialog.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
  declarations: [MarketplaceCardComponent, QuickViewDialogComponent],
  imports: [
    CommonModule,
    RouterLink,
    MaterialModule,
    PipesModule,
    NgxSpinnerModule,
    SwiperModule,
    NgxImageZoomModule,
    SharedModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [MarketplaceCardComponent],
})
export class MarketplaceCardModule {}
